module.exports = " <div class=directory> <h2 class=\"serif uppercase\">Category</h2> <ul> <li v-for=\"category in categories\" :class=\"{ active: selected == category.value }\" class=uppercase> <a @click.prevent=selectCategory(category.value)> {{ category.text }} </a> </li> </ul> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./site/sites/all/themes/custom/abr_theme/js/video-listing/components/CategorySelector.vue
 ** module id = 478
 ** module chunks = 2
 **/